module.exports = __webpack_public_path__ + "img/img1.18821a22.png";